import VendorIndexVue from "@/views/vendor/VendorIndex.vue";

const vendor = [
  {
    path: "/vendor",
    name: "vendor",
    component: VendorIndexVue,
    meta: {
      layout: "default",
      role: ["superadmin","backoffice"],
      public: false,
    },
  },
];

export default vendor;
